import * as React from 'react';
import { observer } from 'mobx-react';
import { classes } from '~utils/Classes';
import { SOCIAL_PROOF_REVIEW } from '../constants/DataTestIds';

export interface ISocialProofReview {
    reviewHeadline: string;
}

export const SocialProofReview = observer(function SocialProofReview(props: ISocialProofReview) {
    const { reviewHeadline } = props;

    if (!reviewHeadline) {
        return null;
    }

    const socialProofReviewClassNames = classes(SOCIAL_PROOF_REVIEW);
    const formattedReview = `"${reviewHeadline}"`;

    return (
        <span data-test-id={SOCIAL_PROOF_REVIEW} className={socialProofReviewClassNames}>
            {formattedReview}
        </span>
    );
});
